<template>
  <div class="loginwrap bs-scope" :class="{'hermes': isHermes }" @touchmove.prevent  v-if="compData.needlogin">
    <div class="login-bgshadow" @click="closeLogin" />
    <div class="login-content" :class="[!isProtocol && 'content-min-height']">
      <div class="login-top">
        <div class="login-top-tit">
          请先注册/登录
        </div>
      </div>
      <!--手机号-->
      <input
        v-model="phone"
        type="tel"
        placeholder="输入手机号"
        maxlength="11"
        class="login-number"
        @input="check"
        @focus="check"
        @blur="checkBlur"
      >
      <div class="login-code">
        <!--验证码-->
        <input
          v-model="code"
          type="tel"
          placeholder="输入验证码"
          maxlength="4"
          class="login-number login-codeinput"
          @input="check"
          @focus="check"
          @blur="checkBlur"
        >
        <div
          class="login-codebtn"
          :class="compData.canClick ? '' : 'login-codebtn-notactive'"
          @click="getcode"
        >
          {{ compData.codebtn }}
        </div>
      </div>
      <div class="agreement-row" v-if="isProtocol">
        <img
          v-show="isAgree"
          src="https://static.didapinche.com/pics/g/mui32ouhz1public_popup_tick_sel.png"
          alt=""
          @click="isAgree = false"
        >
        <img
          v-show="!isAgree"
          src="https://static.didapinche.com/pics/g/k3ic47igqnlchoice_unsel_deep.png"
          alt=""
          @click="isAgree = true"
        >
        <div>
          我已阅读并同意
          <a
            href="https://www.didapinche.com/dida/public/lawrules/index.html?type=2"
            class="text-link"
          >《注册协议》</a>
          <a
            href="https://www.didapinche.com/dida/public/lawrules/index.html?type=1"
            class="text-link"
          >《隐私政策》</a>
          及<a
            href="https://www.didapinche.com/dida/public/lawrules/index.html?type=3"
            class="text-link"
          >《合乘协议》</a>
        </div>
      </div>
      <div
        class="login-btn"
        :class="isLogin ? 'login-btn-active' : ''"
        @click="loginActive"
      >
        确认
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from '../VnToast';
import init from './main'
import './index.css'
export default {
  name: 'vnLogin',
	props: {
    reset:Boolean,
		isProtocol: {
			type: Boolean,
			default: true,
		},
    isSilent: {
			type: Boolean,
			default: false,
		},
    success: {
      typeof:Function,
      default:function(){
        return ()=>{}
      }
    },
    error: {
      typeof:Function,
      default:function(){
        return ()=>{}
      }
    },
    closeLogin: {
      typeof: Function,
      default:function(){
        return ()=>{}
      }
    }
	},
  async mounted(){
        let data = await init(this.success, this.reset, this.isSilent, this.error);
        this.compData = data;
  },
  data() {
    return {
      phone:'',
      compData:{},
      isLogin: false,
      code: '',
      isAgree: false,
      isHermes: window.ENV === "development"
    }
  },
  methods: {
    // 获取验证码
    getcode() {
      if (this.compData.canClick) {
        this.compData.getcode(this.phone);
      }
    },
    loginActive() {
      if (this.isLogin) {
        if (this.isProtocol && !this.isAgree) {
                toast('注册/登录前请先阅读并同意相关协议')
                return
            }
        this.compData.loginActive(this.phone , this.code, this.success, this.close);
      }
    },

    close(){
        this.compData.needlogin = false;
    },
	
    checkBlur() {
      this.check()
    },
    // 校验
    check() {
      if (
        this.phone &&
        /^1[3-9]\d{9}$/.test(this.phone) &&
        this.code &&
        /^\d{4}$/.test(this.code)
      ) {
        this.isLogin = true
      } else {
        this.isLogin = false
      }
    }
  }
}
</script>

